/**
 * Main Menu Icons
 *
 */

import about_the_lib from './graphics/about_the_lib'
import getting_started from './graphics/getting_started'
import usage from './graphics/usage'
import typography from './graphics/typography'
import helper_classes from './graphics/helper_classes'
import components from './graphics/components'
import extensions from './graphics/extensions'
import development from './graphics/development'
import info from './graphics/info'
import contact from './graphics/contact'
import email from './graphics/email'
import change_log from './graphics/change_log'
import story from './graphics/story'
import accessibility from './graphics/accessibility'
import colors from './graphics/colors'
import naming from './graphics/naming'
import special from './graphics/special'
import tools from './graphics/tools'
import fonts from './graphics/fonts'
import inspiration from './graphics/inspiration'
import principles from './graphics/principles'
import ui_guides from './graphics/ui_guides'
import logos from './graphics/logos'
import secondary from './graphics/secondary'
import primary from './graphics/primary'
import elements from './graphics/elements'

export default {
  about_the_lib,
  getting_started,
  usage,
  typography,
  helper_classes,
  components,
  extensions,
  development,
  info,
  contact,
  email,
  change_log,
  story,
  accessibility,
  colors,
  naming,
  special,
  tools,
  fonts,
  inspiration,
  principles,
  ui_guides,
  logos,
  secondary,
  primary,
  elements,
}
